import { SITE } from "@/lib/config";
import { useLang } from "@/lib/i18n";
import { Seo } from "@/components/Seo";
import { Breadcrumbs } from "@/components/Breadcrumbs";

const sections = [
  ["Information we collect", "When you use our contact form, catering quote form or join the Tijuas VIP list, we collect the information you provide: name, phone number, email address, event details and (optionally) birthday month. We also collect standard analytics data such as pages visited, device type and approximate location through tools like Google Analytics and Meta Pixel when those tools are enabled."],
  ["How we use your information", "We use your information to respond to inquiries, prepare catering quotes, send VIP list announcements you opted into, and improve our website and marketing. We do not sell your personal information."],
  ["Marketing consent and opt-out", "You will only receive marketing emails or text messages if you check the consent box when joining the VIP list. Message frequency varies and message and data rates may apply. You can unsubscribe from emails using the link in any message and stop text messages by replying STOP at any time."],
  ["Online ordering", "Online orders are processed by our third-party ordering provider. Payment and order information you enter there is governed by that provider's privacy policy."],
  ["Cookies and analytics", "We may use cookies and similar technologies for analytics and advertising measurement (Google Analytics 4, Google Ads, Meta Pixel). You can control cookies through your browser settings."],
  ["Data sharing", "We share information only with service providers that help us operate the website and communicate with you (for example, email delivery and analytics providers), or when required by law."],
  ["Your choices", `To access, correct or delete your information, or to withdraw consent, email us at ${SITE.email} or call ${SITE.phoneDisplay}.`],
  ["Changes", "We may update this policy from time to time. The latest version will always be posted on this page."],
];

export const PrivacyPage = () => {
  const { t } = useLang();
  return (
    <div data-testid="privacy-page">
      <Seo title="Privacy Policy | Tijuas Tacos Birrieria" description="Privacy policy for Tijuas Tacos Birrieria, Albuquerque NM: how we collect, use and protect information submitted through our website." path="/privacy-policy" />
      <Breadcrumbs items={[{ label: t("nav.privacy"), to: "/privacy-policy" }]} />
      <article className="max-w-3xl mx-auto px-4 py-16">
        <h1 className="font-serif text-5xl text-hacienda-charcoal font-semibold mb-3">Privacy Policy</h1>
        <p className="text-hacienda-gray mb-10">{SITE.legalName} · Last updated June 2026</p>
        <div className="space-y-8">
          {sections.map(([h, body]) => (
            <section key={h}>
              <h2 className="font-serif text-2xl text-hacienda-charcoal font-semibold mb-2">{h}</h2>
              <p className="text-hacienda-gray leading-relaxed">{body}</p>
            </section>
          ))}
        </div>
      </article>
    </div>
  );
};

export default PrivacyPage;
